/**
 * Reviews Script
 * ------------------------------------------------------------------------------
 * A file that contains scripts highly couple code to the Reviews section.
 *
 * @namespace reviews
 */

import Flickity from 'flickity';
import {register} from './../vendor/theme-scripts/theme-sections';
import debounce from '../util/debounce';

const sections = {};

const selectors = {
  reviewWithImage: 'reviews-with-image',
  reviewSlider: '.reviews__slider--',
  reviewSlide: '.review__slide',
  reviewSliderArrow: '.reviews__slider-arrow',
  prevArrow: '[data-prev-arrow]',
  nextArrow: '[data-next-arrow]',
  dataSlides: 'data-slides',
  dataSlideIndex: 'data-slide-index',
  classIsHidden: 'is-hidden',
  classIsSelected: 'is-selected',
  classSliderInitialized: 'reviews__slider--initialized',
  blockquote: 'blockquote',
};

class Reviews {
  constructor(section) {
    this.container = section.container;
    const sectionId = section.id;
    this.slideshow = this.container.querySelector(selectors.reviewSlider + sectionId);
    this.hasImage = this.container.classList.contains(selectors.reviewWithImage);
    this.slides = this.container.querySelectorAll(selectors.reviewSlide);
    this.slidesNumber = this.slides.length;
    this.sliderPrev = this.container.querySelector(selectors.prevArrow);
    this.sliderNext = this.container.querySelector(selectors.nextArrow);
    this.flkty = null;

    this.init();
  }

  init() {
    const self = this;

    this.flkty = new Flickity(this.slideshow, {
      autoPlay: false,
      prevNextButtons: false,
      contain: true,
      pageDots: false,
      adaptiveHeight: true,
      wrapAround: true,
      percentPosition: true,
      cellAlign: 'left',
      draggable: false,
      on: {
        ready: function () {
          self.showArrows();
        },
      },
    });

    window.addEventListener(
      'resize',
      debounce(function () {
        self.showArrows();
        self.flkty.resize();
        if (!self.slideshow.classList.contains(selectors.classSliderInitialized)) {
          self.flkty.select(0);
        }
      }, 100)
    );

    this.sliderPrev.addEventListener('click', function (e) {
      e.preventDefault();

      self.flkty.previous(true);
    });

    this.sliderNext.addEventListener('click', function (e) {
      e.preventDefault();

      self.flkty.next(true);
    });
  }

  showArrows() {
    const slidesNumberCustom = parseInt(this.slideshow.getAttribute(selectors.dataSlides));
    const windowWidth = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;
    let flag = false;

    if (!this.hasImage) {
      const largeDesktopCheck = windowWidth > 1339 && this.slidesNumber > slidesNumberCustom;
      const desktopCheck = windowWidth <= 1339 && windowWidth > 1023 && this.slidesNumber > 3;
      const tabletCheck = windowWidth <= 1023 && windowWidth > 767 && this.slidesNumber > 2;
      const mobileCheck = windowWidth <= 767 && this.slidesNumber > 1;

      if (largeDesktopCheck || desktopCheck || tabletCheck || mobileCheck) {
        flag = true;
      }
    } else if (this.hasImage && this.slidesNumber > 1) {
      flag = true;
    }

    if (flag) {
      this.sliderPrev.classList.remove(selectors.classIsHidden);
      this.sliderNext.classList.remove(selectors.classIsHidden);
      this.slideshow.classList.add(selectors.classSliderInitialized);
    } else {
      this.sliderPrev.classList.add(selectors.classIsHidden);
      this.sliderNext.classList.add(selectors.classIsHidden);
      this.slideshow.classList.remove(selectors.classSliderInitialized);
    }
  }

  onBlockSelect(evt) {
    const slide = this.slideshow.querySelector(`${selectors.reviewSlide}--${evt.detail.blockId}`);
    const slideIndex = parseInt(slide.getAttribute(selectors.dataSlideIndex));

    if (this.slideshow.classList.contains(selectors.classSliderInitialized)) {
      this.flkty.select(slideIndex);
    } else {
      this.flkty.select(0);
    }
  }
}

const ReviewsSection = {
  onLoad() {
    sections[this.id] = new Reviews(this);
  },
  onUnload(e) {
    sections[this.id].onUnload(e);
  },
  onBlockSelect(e) {
    sections[this.id].onBlockSelect(e);
  },
};

register('reviews', ReviewsSection);
